import { bl_mrp_job_template_ext_RowClass, bl_mrp_job_template_hdr_RowClass, bl_mrp_job_template_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpJobTemplateContainerModel extends BaseContainerModel {
  bl_mrp_job_template_hdr: bl_mrp_job_template_hdr_RowClass = new bl_mrp_job_template_hdr_RowClass();
  bl_mrp_job_template_exts : bl_mrp_job_template_ext_RowClass[] = [];
  bl_mrp_job_template_lines: bl_mrp_job_template_line_RowClass[] = [];
}
